exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3XnU1DZiD6daIApAOrCdwM{display:-webkit-box;display:-ms-flexbox;display:flex}._2DR1SRhuUBy8y-7DO1KD5p{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._2DR1SRhuUBy8y-7DO1KD5p{margin-top:2px}html[dir=ltr] ._2DR1SRhuUBy8y-7DO1KD5p{padding-left:0}html[dir=rtl] ._2DR1SRhuUBy8y-7DO1KD5p{padding-right:0}._1z4cMAA6XzOY3uTga1DJDv{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._1z4cMAA6XzOY3uTga1DJDv{padding-left:0}html[dir=rtl] ._1z4cMAA6XzOY3uTga1DJDv{padding-right:0}._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{font-size:12px}html[dir] ._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{margin-top:2px}html[dir=ltr] ._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{margin-left:0}html[dir=rtl] ._1z4cMAA6XzOY3uTga1DJDv ._2bbbxifO4lVoIDavAP3u3j{margin-right:0}", ""]);

// exports
exports.locals = {
	"ignoreSubsequentRulesCheckbox": "_3XnU1DZiD6daIApAOrCdwM",
	"ignoreSubsequentRulesLearnMore": "_2DR1SRhuUBy8y-7DO1KD5p",
	"ruleCommandButton": "_1z4cMAA6XzOY3uTga1DJDv",
	"icon": "_2bbbxifO4lVoIDavAP3u3j"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/config/mail/owa-inbox-rules-option/lib/components/InboxRulesEdit.scss
// module id = 5215
// module chunks = 2